"use client";
import type { FC } from "react";
import { memo, useEffect, useCallback, useRef, Suspense } from "react";
import { onCheckAuth, onGetUser } from "@/api/apiLogin";
import { useSearchParams } from "next/navigation";
import { LOGING_CALLBACK_URL } from "@/app/config";
import { onCreateOrder } from "@/api/apiOrder";

// 内部组件，处理 useSearchParams
const LogingBoxInner: FC = () => {
  const searchParams = useSearchParams();
  const hasProcessed = useRef(false);

  const loginByCode = useCallback(
    async (redirectUri: string, code: string, scene: string) => {
      console.log(redirectUri, "redirectUriredirectUri dft");
      console.log(code, "codedft");

      onCheckAuth(code, redirectUri).then(async (result) => {
        console.log(result, "resultresult dft");
        const { id_token, access_token } = result;

        if (!id_token) {
          return;
        }
        localStorage.setItem("fellou.id_token", id_token);
        localStorage.setItem("fellou.access_token", access_token);

        onGetUser(id_token).then(async (userInfo) => {
          console.log(userInfo, "userInfouserInfo dft");
          localStorage.setItem("fellou.userInfo", JSON.stringify(userInfo));
          window.dispatchEvent(new CustomEvent("login_success", { detail: true }));

          if (scene === "stripe") {
            // window.location.href = "/stripe";
            const productId = searchParams.get("productId");
            if (productId) {
              const res = await onCreateOrder(productId, window.location.origin + "/account");
              const paymentUrl = res.data.paymentUrl;
              window.location.href = paymentUrl;
            }
          }
        });

        // 清除地址栏中的 code 和 state 参数
        const url = new URL(window.location.href);
        url.searchParams.delete("code");
        url.searchParams.delete("state");
        window.history.replaceState({}, "", url.toString());
      });
    },
    [searchParams]
  );

  const handleCallback = useCallback(async () => {
    try {
      const scene = decodeURIComponent(searchParams.get("scene") || "");
      const currentUrl = new URL(window.location.href);
      const baseRedirectUri = `${currentUrl.origin}/${LOGING_CALLBACK_URL}${scene}`;

      // 构建包含所有参数（除了 state 和 code）的 redirectUri
      const redirectUriParams = new URLSearchParams();
      for (const [key, value] of currentUrl.searchParams.entries()) {
        if (key !== "state" && key !== "code" && key !== "scene") {
          redirectUriParams.append(key, value);
        }
      }

      const redirectUri = redirectUriParams.toString()
        ? `${baseRedirectUri}&${redirectUriParams.toString()}`
        : baseRedirectUri;

      const code = searchParams.get("code");

      if (!code) {
        throw new Error("No code found");
      }

      loginByCode(redirectUri, code, scene);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      // 登录失败，推荐再次跳转到登录页面
      console.error("Login failed, please try again");
    }
  }, [loginByCode, searchParams]);

  useEffect(() => {
    const code = searchParams.get("code");
    if (code && !hasProcessed.current) {
      hasProcessed.current = true;
      handleCallback();
    }
  }, [handleCallback, searchParams]);

  return <></>;
};

// 主组件，包装在 Suspense 中
const LogingBox: FC = () => {
  return (
    <Suspense fallback={<></>}>
      <LogingBoxInner />
    </Suspense>
  );
};

export default memo(LogingBox);
